<template>
  <v-container fluid>
    <div v-if="survey.last_page > 0">
      <HeaderPage
        :survey="survey"
        v-if="survey"
        style="width: 210mm; height: 297mm; margin: auto"
        class="mb-10"
        :distances="distances"
      />
      <ViaggiStandardPage
        v-if="standardRows.length > 0"
        :rows="standardRows"
        class="mt-10 mb-10"
        style="margin: auto"
      />
      <NonViaggiStandardPage
        v-if="roundAndShuttleRows.length > 0"
        :rows="roundAndShuttleRows"
        class="mb-10"
        style="margin: auto"
      />
    </div>
  </v-container>
</template>

<script>
// Components
import HeaderPage from '@/components/v1/JourneyPreview/HeaderPage.vue'
import ViaggiStandardPage from '@/components/v1/JourneyPreview/ViaggiStandardPage.vue'
import NonViaggiStandardPage from '@/components/v1/JourneyPreview/NonViaggiStandardPage.vue'

// Managers
import { toDocument } from '@/models/converters'
import { ristrutturaViaggi, standardJourneyToRow, roundJourneyToRow, standardEmptyJourneyToRow } from '@/models/manager'

// Store
import { mapState } from 'vuex'

// Component
export default {
  components: {
    HeaderPage,
    ViaggiStandardPage,
    NonViaggiStandardPage,
  },
  computed: {
    ...mapState('survey', ['survey']),
    doc() {
      return toDocument(this.survey)
    },
    restructuredJourneys() {
      if (!this.survey) return []
      return ristrutturaViaggi(this.survey)
    },
    distances() {
      return this.restructuredJourneys.reduce(
        (acc, cur) => {
          switch (cur._meta.journey_type) {
            case 1:
            case 2:
              acc.loaded += cur.distance_total
              break
            case 4:
              acc.empty += cur.distance_total
              break
            default:
              acc.loaded += cur.journeys_count * cur.distance_loaded
              acc.empty += cur.journeys_count * cur.distance_empty
              break
          }
          return acc
        },
        { loaded: 0, empty: 0 }
      )
    },
    standardRows() {
      return this.restructuredJourneys
        .filter((e) => [1, 4].includes(e.type))
        .map((el) => {
          if (el.type === 1) return standardJourneyToRow(el)
          if (el.type === 4) return standardEmptyJourneyToRow(el)
          return null
        })
    },
    roundAndShuttleRows() {
      return this.restructuredJourneys
        .filter((e) => [2, 3].includes(e.type))
        .map((el) => {
          if (el.type === 2) return roundJourneyToRow(el)
          if (el.type === 3) return roundJourneyToRow(el)
          return null
        })
    },
    rows() {
      if (!this.survey) return []
      return ristrutturaViaggi(this.survey)
    },
  },
}
</script>

<style lang="scss" scoped>
pre {
  font-family: 'SF Mono', monospace;
  font-size: 13.6px;
  font-weight: 500;
  border: 2px solid #ddd;
  border-radius: 6px;
  padding: 0.5rem;
  background-color: #fafafa;
}
</style>
